import mobile from "./routes/mobile";
import pc from "./routes/pc";

const redirectPath = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent) ? "mobile" : "pc";
const routerConfig = [
  {
    path: "/",
    redirect: redirectPath
  },
  ...mobile,
  ...pc
];

export default routerConfig;
